import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47b9b888"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 1,
  class: "img-nav"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]

import WOW from "wowjs";
import { onMounted, ref } from "vue";
import { getServiceCenter, getServiceCenterContent } from "@/api/product";
import RichTextRenderer from "@/components/RichTextRenderer.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceCenter',
  setup(__props) {

const baseUrl = ref(process.env.VUE_APP_BASE_URL);
const platformList = ref([]);
const currentId = ref("");
const content = ref({
  title: "",
  content: "",
});
onMounted(() => {
  new WOW.WOW({ live: false }).init();
  getServiceCenter().then((res) => {
    platformList.value = res.data;
  });
});
const tapToDetail = (id) => {
  currentId.value = id;
  getServiceCenterContent(id).then((res) => {
    console.log(res);
    content.value = res.data.content;
    content.value.content = content.value.content.replace(
      /src="\/media\//g,
      `src="${process.env.VUE_APP_BASE_URL}/media/`
    );
    // content.value.content = content.value.content.replace(
    //   /src="\/media\/uploads\/20/g,
    //   `style="width:100%;" src="${process.env.VUE_APP_BASE_URL}/media/uploads/20`
    // );
  });
};
const returnAll = () => {
  getServiceCenter().then((res) => {
    console.log(res);
    platformList.value = res.data;
  });
  currentId.value = "";
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { class: "cont animate__animated animate__fadeInLeft wow" }, {
    default: _withCtx(() => [
      (currentId.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_el_button, {
              onClick: returnAll,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("返回")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h2", null, _toDisplayString(content.value.title), 1)
            ]),
            _createVNode(RichTextRenderer, {
              content: content.value.content
            }, null, 8, ["content"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platformList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item-nav",
                onClick: ($event: any) => (tapToDetail(item.id)),
                key: index
              }, [
                _createElementVNode("img", {
                  class: "cover-img",
                  src: baseUrl.value + item.cover,
                  alt: ""
                }, null, 8, _hoisted_5),
                _createElementVNode("h3", null, _toDisplayString(item.title), 1)
              ], 8, _hoisted_4))
            }), 128))
          ]))
    ]),
    _: 1
  }))
}
}

})